import React, { useContext, useEffect, useState } from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { IDishesContext, DishesContext } from '../../../../../dishesState/dishesContext';
import style from './PriceField.module.scss';

interface IPriceField {
	type: 'from' | 'to';
}

const PriceField = ({ type }: IPriceField) => {
	const { setPriceFrom, setPriceTo, priceFrom, priceTo } = useContext<IDishesContext>(DishesContext);
	const [value, setValue] = useState<string>('');
	const [goToFirstPage, setGoToFirstPage] = useState(false);
	const { t } = useTranslation('listing');

	const priceType = type === 'from' ? priceFrom : priceTo;

	useEffect(() => {
		const timeoutID = setTimeout(() => {
			goToFirstPage && (type === 'from' ? setPriceFrom(value) : setPriceTo(value));
			setGoToFirstPage(false);
		}, 800);
		return () => {
			setGoToFirstPage(false);
			return clearTimeout(timeoutID);
		};
	}, [value]);

	useEffect(() => {
		if (priceType !== value) {
			setValue(priceType);
		}
	}, [priceType]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const onlyDigits = e.target.value.replace(/\D/g, '');
		setValue(onlyDigits);
		setGoToFirstPage(true);
	};

	return (
		<div className={style.priceInput}>
			<Input onChange={handleChange} value={value} placeholder={t(type)} />
		</div>
	);
};

export default PriceField;
